module.exports = __webpack_public_path__ + "static/media/icon-chevron-down_thick.d606e26c.svg";